
<template>
  <div>
    <v-subheader>Detalhes
    </v-subheader>
    <v-row class="px-4" row wrap justify="space-between">
      <div>Criado em: {{ new Date(deal.created_at.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR') }}</div>
      <div>Pagamento em: <b>{{ deal.payment_option.description }}</b>, <b>{{ deal.payment_time.description }}</b> </div>
    </v-row>

    <v-subheader>Produtos negociados
    </v-subheader>

    <v-col cols='12'>
      <list-item :show_crud_item="false" :items="deal.deal_items"></list-item>
    </v-col>
  </div>
</template>

<script>

export default {
  components: {
    ListItem: () => import('./listItems.vue'),
  },
  props: {
    deal: {
      type: Object,
    },
  },
}
</script>
